import React from 'react'
import styles from './PrivacyPolicyPage.module.scss'
import { ReactComponent as LockIcon } from '../../../../assets/icons/privacy/lock.svg'
import { ReactComponent as PrivacyIcon } from '../../../../assets/icons/privacy/privacy.svg'
import { ReactComponent as DataIcon } from '../../../../assets/icons/privacy/data.svg'
import { ReactComponent as ControlIcon } from '../../../../assets/icons/privacy/control.svg'
import { ReactComponent as ShieldIcon } from '../../../../assets/icons/about/shield.svg'
import { ReactComponent as TargetIcon } from '../../../../assets/icons/about/target.svg'
import { ReactComponent as GlobeIcon } from '../../../../assets/icons/about/globe.svg'

const PrivacyPolicyPage = ({ goBack }) => {
  const getIcon = (iconName) => {
    const icons = {
      lock: LockIcon,
      privacy: PrivacyIcon,
      data: DataIcon,
      control: ControlIcon,
      shield: ShieldIcon,
      target: TargetIcon,
      globe: GlobeIcon
    }
    const Icon = icons[iconName]
    return Icon ? <Icon className={styles.icon} /> : null
  }

  const sections = [
    {
      title: 'Сбор информации',
      icon: 'data',
      content: [
        'Мы собираем информацию, которую вы предоставляете при регистрации, включая имя, email и контактные данные',
        'Автоматически собираемые данные: IP-адрес, тип браузера, время посещения и взаимодействие с сервисами',
        'Информация о заказах и транзакциях при использовании наших коммерческих сервисов',
        'Файлы cookie для улучшения пользовательского опыта и персонализации контента'
      ]
    },
    {
      title: 'Использование данных',
      icon: 'target',
      content: [
        'Предоставление и улучшение качества наших сервисов',
        'Персонализация контента и рекомендаций на основе ваших предпочтений',
        'Обработка заказов и транзакций',
        'Отправка важных уведомлений о работе сервисов',
        'Анализ использования платформы для улучшения функциональности',
        'Обеспечение безопасности и предотвращение мошенничества'
      ]
    },
    {
      title: 'Защита данных',
      icon: 'lock',
      content: [
        'Использование шифрования SSL/TLS для защиты передачи данных',
        'Безопасное хранение данных на защищенных серверах',
        'Регулярные аудиты безопасности и обновления систем',
        'Ограниченный доступ к личным данным только авторизованному персоналу',
        'Резервное копирование для предотвращения потери данных',
        'Соблюдение международных стандартов безопасности данных'
      ]
    },
    {
      title: 'Ваши права',
      icon: 'control',
      content: [
        'Право на доступ к своим персональным данным',
        'Право на исправление неточной или неполной информации',
        'Право на удаление ваших данных при определенных обстоятельствах',
        'Право на ограничение обработки ваших данных',
        'Право на портативность данных',
        'Право отозвать согласие на обработку в любое время',
        'Право подать жалобу в надзорный орган'
      ]
    },
    {
      title: 'Файлы Cookie',
      icon: 'data',
      content: [
        'Мы используем основные cookie для функционирования сайта',
        'Аналитические cookie помогают нам понимать, как используется платформа',
        'Маркетинговые cookie для показа релевантной рекламы',
        'Вы можете управлять настройками cookie в вашем браузере',
        'Отключение cookie может ограничить функциональность некоторых сервисов'
      ]
    },
    {
      title: 'Передача данных',
      icon: 'globe',
      content: [
        'Мы не продаем ваши персональные данные третьим лицам',
        'Данные могут передаваться партнерам для предоставления сервисов',
        'Все партнеры обязаны соблюдать политику конфиденциальности',
        'Передача данных осуществляется только с вашего согласия или по закону',
        'При международной передаче данных применяются соответствующие меры защиты'
      ]
    },
    {
      title: 'Хранение данных',
      icon: 'shield',
      content: [
        'Мы храним данные столько, сколько необходимо для предоставления сервисов',
        'Неактивные аккаунты могут быть удалены после определенного периода',
        'Финансовые данные хранятся в соответствии с требованиями законодательства',
        'По запросу пользователя данные могут быть удалены досрочно',
        'Резервные копии хранятся в течение ограниченного времени'
      ]
    },
    {
      title: 'Дети и конфиденциальность',
      icon: 'privacy',
      content: [
        'Наши сервисы предназначены для лиц старше 13 лет',
        'Мы не собираем намеренно данные детей младше 13 лет',
        'Если вы узнали, что ребенок предоставил нам данные, свяжитесь с нами',
        'Родители имеют право запросить удаление данных своих детей'
      ]
    }
  ]

  const principles = [
    {
      title: 'Прозрачность',
      description: 'Мы открыто информируем о том, как собираем и используем ваши данные',
      icon: 'privacy'
    },
    {
      title: 'Безопасность',
      description: 'Применяем передовые технологии для защиты вашей информации',
      icon: 'shield'
    },
    {
      title: 'Контроль',
      description: 'Вы всегда контролируете свои данные и можете изменить настройки',
      icon: 'control'
    },
    {
      title: 'Минимизация',
      description: 'Собираем только необходимые данные для работы сервисов',
      icon: 'data'
    }
  ]

  return (
    <div className={styles.page}>
      <div className={styles.heroSection}>
        <h1 className={styles.heroTitle}>Политика конфиденциальности</h1>
        <p className={styles.heroSubtitle}>Защита ваших данных</p>
      </div>

      <div className={styles.principlesSection}>
        <h2 className={styles.sectionTitle}>Наши принципы</h2>
        <div className={styles.principlesGrid}>
          {principles.map((principle, index) => (
            <div key={index} className={styles.principleCard}>
              <div className={styles.principleIcon}>{getIcon(principle.icon)}</div>
              <h3 className={styles.principleTitle}>{principle.title}</h3>
              <p className={styles.principleDescription}>{principle.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.contentSection}>
        {sections.map((section, index) => (
          <div key={index} className={styles.contentBlock}>
            <div className={styles.blockHeader}>
              <div className={styles.blockIcon}>{getIcon(section.icon)}</div>
              <h2 className={styles.blockTitle}>{section.title}</h2>
            </div>
            <ul className={styles.blockList}>
              {section.content.map((item, idx) => (
                <li key={idx} className={styles.listItem}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className={styles.contactSection}>
        <div className={styles.contactBox}>
          <h2 className={styles.contactTitle}>Вопросы о конфиденциальности?</h2>
          <p className={styles.contactText}>
            Если у вас есть вопросы о нашей политике конфиденциальности или вы хотите воспользоваться 
            своими правами, пожалуйста, свяжитесь с нами:
          </p>
          <div className={styles.contactInfo}>
            <div className={styles.infoItem}>
              <span className={styles.infoIcon}>📧</span>
              <span className={styles.infoText}>ncore@gmail.com</span>
            </div>
            <div className={styles.infoItem}>
              <span className={styles.infoIcon}>📞</span>
              <span className={styles.infoText}>0600006032</span>
            </div>
          </div>
          <p className={styles.responseTime}>
            Мы ответим на ваш запрос в течение 48 часов
          </p>
        </div>
      </div>

      <div className={styles.agreementSection}>
        <div className={styles.agreementBox}>
          <h3 className={styles.agreementTitle}>Согласие с политикой</h3>
          <p className={styles.agreementText}>
            Используя наши сервисы, вы соглашаетесь с условиями данной политики конфиденциальности. 
            Мы можем обновлять эту политику время от времени, и важные изменения будут доведены до вашего сведения.
          </p>
          <p className={styles.agreementText}>
            Мы рекомендуем периодически просматривать эту страницу, чтобы быть в курсе любых изменений.
          </p>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicyPage
